import dropdownIconUrl from './assets/dropdown-icon.svg';
import {type MegaMenuDropdownColumn, type SimpleDropdownItem} from './types';

export const ARROW_ICON = dropdownIconUrl as unknown as string;

export const PLATFORM_DROPDOWN_CONFIG: MegaMenuDropdownColumn[] = [
  {
    title: 'Models',
    url: 'https://wandb.ai/site/models/',
    isLinkableTitle: true,
    items: [
      {
        name: 'Experiments',
        description: 'Track and visualize your ML experiments',
        url: 'https://wandb.ai/site/experiment-tracking/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/experiments.svg',
      },
      {
        name: 'Sweeps',
        description: 'Optimize your hyperparameters',
        url: 'https://wandb.ai/site/sweeps/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/sweeps.svg',
      },
      {
        name: 'Tables',
        description: 'Visualize and explore your ML data',
        url: 'https://wandb.ai/site/tables/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/tables.svg',
      },
      {
        name: 'Reports',
        description: 'Visualize and explore your ML data',
        url: 'https://wandb.ai/site/reports/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/reports.svg',
      },
    ],
  },
  {
    title: 'Training',
    url: 'https://wandb.ai/site/wb-training/',
    isLinkableTitle: true,
    items: [
      {
        name: 'Serverless RL',
        description: 'Fine-tune LLMs without managing GPUs',
        url: 'https://wandb.ai/site/serverless-rl/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/serverless-rl.svg',
      },
      {
        name: 'ART',
        description: 'Open-source RL framework',
        url: 'https://wandb.ai/site/art/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/art.svg',
      },
      {
        name: 'Ruler',
        description: 'Automated reward function for RL',
        url: 'https://wandb.ai/site/ruler/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/ruler.svg',
      },
    ],
  },
  {
    title: 'Inference',
    url: 'https://wandb.ai/site/inference/',
    isLinkableTitle: true,
    items: [
      {
        name: 'OpenAI OSS',
        description: 'GPT OSS 20B, GPT OSS 120B',
        url: 'https://wandb.ai/site/inference/openai-models/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/openai-oss.svg',
      },
      {
        name: 'Alibaba Qwen3',
        description: '23B A22B, 23B5B Thinking, Coder 480B',
        url: 'https://wandb.ai/site/inference/qwen-models/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/qwen3.svg',
      },
      {
        name: 'Meta Llama',
        description: 'Llama 4 Scout, 3.3 70B, 3.1 8B',
        url: 'https://wandb.ai/site/inference/meta-models/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/meta-llama.svg',
      },
      {
        name: 'MoonshotAI Kimi',
        description: 'Kimi K2',
        url: 'https://wandb.ai/site/inference-model/moonshotai-kimi-k2/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/kimi.svg',
      },
      {
        name: 'Microsoft Phi',
        description: 'Phi 4 Mini 3.8B',
        url: 'https://wandb.ai/site/inference-model/microsoft-phi-4-mini-3.8b/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/phi.svg',
      },
      {
        name: 'Hangzhou DeepSeek',
        description: 'DeepSeek V3.1, V3-0324, R1-0528',
        url: 'https://wandb.ai/site/inference/deepseek-models/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/deepseek.svg',
      },
      {
        name: 'Z.ai',
        description: 'Z.AI GLM 4.5',
        url: 'https://wandb.ai/site/inference-model/z-ai-glm-4-5/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/z-ai.svg',
      },
    ],
  },
  {
    title: 'Weave',
    url: 'https://wandb.ai/site/weave/',
    isLinkableTitle: true,
    items: [
      {
        name: 'Traces',
        description: 'Explore and debug AI applications',
        url: 'https://wandb.ai/site/traces/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/traces.svg',
      },
      {
        name: 'Evaluations',
        description: 'Rigorous evaluations of AI applications',
        url: 'https://wandb.ai/site/evaluations/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/evaluations.svg',
      },
      {
        name: 'Playground',
        description: 'Explore prompts and models',
        url: 'https://wandb.ai/site/playground/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/playground.svg',
      },
      {
        name: 'Agents',
        description: 'Observability tools for agentic systems',
        url: 'https://wandb.ai/site/agents/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/agents.svg',
      },
      {
        name: 'Guardrails',
        description: 'Block prompt attacks and harmful outputs',
        url: 'https://wandb.ai/site/guardrails/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/guardrails-1.svg',
      },
      {
        name: 'Monitors',
        description: 'Continuously improve in production',
        url: 'https://wandb.ai/site/monitors/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/monitors.svg',
      },
    ],
  },
  {
    title: 'Core',
    placement: 'bottom',
    items: [
      {
        name: 'Registry',
        description: 'Publish and share your ML models and datasets',
        url: 'https://wandb.ai/site/registry/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/registry.svg',
      },
      {
        name: 'Skills',
        description: 'Skills for coding agents',
        url: 'https://wandb.ai/site/skills/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2026/04/skills-icon.svg',
      },
      {
        name: 'SDK',
        description: 'Log ML experiments and artifacts at scale',
        url: 'https://wandb.ai/site/sdk/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/sdk.svg',
      },
      {
        name: 'Automations',
        description: 'Trigger workflows automatically',
        url: 'https://wandb.ai/site/automations/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/automations.svg',
      },
    ],
  },
];

export const SOLUTIONS_DROPDOWN_CONFIG: MegaMenuDropdownColumn[] = [
  {
    title: 'Use Cases',
    titleIcon: ARROW_ICON as unknown as string,
    items: [
      {
        name: 'Train LLMs',
        url: 'https://wandb.ai/site/solutions/large-scale-models/',
      },
      {
        name: 'Fine-tune LLMs',
        url: 'https://wandb.ai/site/solutions/llm-fine-tuning/',
      },
      {
        name: 'Computer Vision',
        url: 'https://wandb.ai/site/solutions/computer-vision/',
      },
      {
        name: 'Time Series',
        url: 'https://wandb.ai/site/solutions/time-series/',
      },
      {
        name: 'Recommender Systems',
        url: 'https://wandb.ai/site/solutions/recommender-systems/',
      },
      {
        name: 'Classification & Regression',
        url: 'https://wandb.ai/site/solutions/classification-regression/',
      },
    ],
  },
  {
    title: 'Industries',
    titleIcon: ARROW_ICON as unknown as string,
    items: [
      {
        name: 'Autonomous Vehicles',
        url: 'https://wandb.ai/site/solutions/autonomous-vehicles/',
      },
      {
        name: 'Communications',
        url: 'https://wandb.ai/site/solutions/communications-media-entertainment/',
      },
      {
        name: 'Financial Services',
        url: 'https://wandb.ai/site/solutions/finance/',
      },
      {
        name: 'Healthcare & Life Sciences',
        url: 'https://wandb.ai/site/solutions/healthcare-and-life-sciences/',
      },
      {
        name: 'Public Sector',
        url: 'https://wandb.ai/site/solutions/public-sector/',
      },
      {
        name: 'Scientific Research',
        url: 'https://wandb.ai/site/solutions/scientific-research/',
      },
    ],
  },
  {
    title: 'Case Studies',
    url: 'https://wandb.ai/site/customers/',
    isLinkableTitle: true,
    titleIcon: ARROW_ICON as unknown as string,
    items: [
      {
        name: 'Canva',
        description: 'Learn how Canva leverages W&B to deploy models',
        url: 'https://wandb.ai/site/customers/canva-model-registry/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/canva.svg',
      },
      {
        name: 'Microsoft',
        description: 'Learn how Microsoft uses W&B for their ML projects',
        url: 'https://wandb.ai/site/customers/how-microsoft-leveraged-weights-biases-to-build-the-models-behind-ink/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/microsoft.svg',
      },
      {
        name: 'Toyota',
        description: 'Learn how Toyota uses W&B for autonomous driving',
        url: 'https://wandb.ai/site/customers/woven/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/toyota-1.svg',
      },
      {
        name: 'OpenAI',
        description: 'Learn how OpenAI Robotics uses W&B for large scale ML',
        url: 'https://wandb.ai/site/customers/learning-dexterity-end-to-end-using-weights-biases-reports/',
        icon: 'https://site.wandb.ai/wp-content/uploads/2025/10/openai-1.svg',
      },
    ],
  },
];

export const ENTERPRISE_DROPDOWN_CONFIG = {
  type: 'single-column',
  items: [
    {name: 'Security', url: 'https://wandb.ai/site/security/'},
    {
      name: 'Deployment',
      url: 'https://wandb.ai/site/for-enterprise/deployment-options/',
    },
    {name: 'Performance', url: 'https://wandb.ai/site/models-performance/'},
    {name: 'Partners', url: 'https://wandb.ai/site/partners/'},
    {name: 'Support', url: 'https://wandb.ai/site/support/'},
  ] as SimpleDropdownItem[],
};

export const RESOURCES_DROPDOWN_CONFIG = {
  type: 'single-column',
  style: {maxWidth: '165px'},
  ulStyle: {minWidth: '100%', whiteSpace: 'normal' as const},
  items: [
    {name: 'AI Courses', url: 'https://wandb.ai/site/courses/'},
    {name: 'Blog', url: '/fully-connected'},
    {name: 'Articles', url: 'https://wandb.ai/site/articles/'},
    {name: 'Podcast', url: 'https://wandb.ai/site/resources/podcast/'},
    {name: 'Whitepapers', url: 'https://wandb.ai/site/resources/whitepapers/'},
    {name: 'Events & Webinars', url: 'https://wandb.ai/site/resources/events/'},
    {name: 'Press', url: 'https://wandb.ai/site/press-releases/'},
  ] as SimpleDropdownItem[],
};
